@if ({ row: columnData | async }; as $) {
  @if ($.row && $.row.is_ewallet_deposit && $.row.is_ewallet_deposit == true) {
    <div class="flex align-items-center">
      <i class="fa fa-wallet mr-2"></i>
      {{ 'INVOICE.COLUMNS.E_WALLET' | translate }}
    </div>
  } @else {
    @if ($.row.invoiceNumbers && $.row.invoiceNumbers.length > 0) {
      <div>
        @for (invoice of $.row.invoiceNumbers; track invoice) {
          <a
            class="text-primary"
            href="javascript:void(0)"
            (click)="OpenInvoiceDetails(invoice)"
            >{{ invoice }}</a
          >
        }
      </div>
    } @else {
      <span>{{ $.row.inv_number_prefix }}</span>
    }
  }
}
